"use strict";

require("core-js/modules/es.object.define-property.js");
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require("core-js/modules/es.regexp.exec.js");
var _isMiniprogram = _interopRequireDefault(require("./isMiniprogram"));
var UA = navigator.userAgent;
var client = '其他';
if (/58ZhuanZhuan$/g.test(UA)) {
  if (/\(i[^;]+;( U;)? CPU.+Mac OS X/gi.test(UA)) {
    client = '买家app_IOS';
  } else {
    // android
    client = '买家app_Andriod';
  }
} else if (/ZhuanZhuanSeller$/g.test(UA)) {
  if (/\(i[^;]+;( U;)? CPU.+Mac OS X/gi.test(UA)) {
    client = '卖家app_IOS';
  } else {
    // android
    client = '卖家app_Andriod';
  }
} else if (/checkapp/g.test(UA)) {
  if (/\(i[^;]+;( U;)? CPU.+Mac OS X/gi.test(UA)) {
    client = '切克app_IOS';
  } else {
    // android
    client = '切克app_Andriod';
  }
} else if (/58ua="58app"/g.test(document.cookie) || /WUBA/gi.test(UA)) {
  // 58
  client = '58APP';
} else if (/ganji/g.test(UA)) {
  // ganji
  client = '赶集APP';
} else if (/MicroMessenger/g.test(UA)) {
  // 微信浏览器
  client = '微信浏览器';
  if ((0, _isMiniprogram["default"])()) {
    client = '小程序';
  }
} else if (/QQ\//g.test(UA)) {
  // 手机qq浏览器
  client = 'QQ浏览器';
} else if (/cmblife/gi.test(UA)) {
  // 招商银行
  client = '招商银行';
} else if (/WeiBo/gi.test(UA)) {
  // 微博
  client = '微博';
} else if (/UCBrowser|UCWEB/gi.test(UA)) {
  // UC浏览器
  client = 'UC浏览器';
} else if (/AlipayClient/gi.test(UA)) {
  // 支付宝
  client = '支付宝';
} else {
  // m端 pc端
  if (/(Android|webOS|iPhone|iPad|iPod|BlackBerry|Windows Phone|SymbianOS|ToutiaoMicroApp|AppleWebKit.*Mobile.*)/i.test(UA)) {
    client = '其他移动端';
  } else {
    client = 'PC';
  }
}
var _default = client;
exports["default"] = _default;